<script lang="ts">
    import { onMount, getContext } from "svelte";
    import { navigate } from "svelte-navigator";
    import ProductCase from "../product/ProductCase.svelte";
    import ProductEditForm from "../product/ProductEditForm.svelte";
    import ProductSheet from "../product/ProductSheet.svelte";
    import { api, swClient } from "../stores";
    import ConfirmPopup from "../modals/ConfirmPopup.svelte";

    export let product_uid;
    export let document_uid;
    let product = null;
    let productBackup = null;
    let campaign = null;
    let codeOpe: string = null;
    let isInit: boolean = false;
    const { open } = getContext("simple-modal");

    onMount(async () => {
        const document = await $swClient.getDocument(document_uid);
        campaign = await $swClient.getCampaign(document.campaign_uid);
        for (let i = 0; i < campaign.attrs.length; i++) {
            const attr = campaign.attrs[i];
            if (attr.key === "code") {
                codeOpe = attr.value;
                break;
            }
        }
        if (product_uid) {
            $api.getProduct(product_uid).then((res) => {
                product = res;
                productBackup = JSON.parse(JSON.stringify(product));
                // if(product.images.length === 0) {
                //     refProduct.images = ['/no_visual.jpg'];
                // }
            });
        } else {
            product = {
                uid: "",
                pageUid: "",
                operationUid: "",
                categoriesParentUid: [],
                categoryChildUid: "",
                name: "",
                brand: "",
                description: "",
                price: "",
                thumbnail: "",
                mention: "",
                codelec: "",
                packagingType: "",
                erratum: "",
                acheterEnLigneUrl: "",
                images: [],
                logos: [],
                pictos: [],
                isCC: false,
                ecoPart: "",
                greenTaxFurniture: "",
                greenTaxElectronic: "",
                MEA: "",
                ean: "",
                priceWithoutDiscount: "",
                discountAmount: "",
                discountUnit: "",
                discountLabel: "",
                discountedPriceLot: "",
                discountedPriceSecondProduct: "",
                meca: "meca1",
                conditioning: "",
                offertX: "",
                offertY: "",
                discountPriceQty: "",
                origine: "",
                legalNotices: [],
                unavailability: [],
                added: false,
                lowerprice: false,
                displaySupplierRef: false,
                supplierRef: "",
                mandatStartDate: "",
                mandatEndDate: "",
                ecatOnly: "",
                priceFrom: "",
                france1: false,
                france2: false,
                france3: false,
                isPartner: false,
            };
            productBackup = JSON.parse(JSON.stringify(product));
            // if(product.images.length === 0) {
            //     refProduct.images = ['/no_visual.jpg'];
            // }
        }
        isInit = true;
    });

    function confirmNavigation() {
        if (!deepEqual(product, productBackup)) {
            open(
                ConfirmPopup,
                {
                    onOkay: () => navigate(`/admin/products/${document_uid}`),
                    title: `Vos modifications ne seront pas sauvegardées, souhaitez-vous continuer ?`,
                    content: "",
                },
                {
                    closeOnOuterClick: false,
                    closeOnEsc: false,
                    closeButton: false,
                }
            );
        } else {
            navigate(`/admin/products/${document_uid}`);
        }
    }

    function deepEqual(object1, object2): boolean {
        const keys1 = Object.keys(object1);
        const keys2 = Object.keys(object2);
        if (keys1.length !== keys2.length) {
            return false;
        }
        for (const key of keys1) {
            const val1 = object1[key];
            const val2 = object2[key];
            const areObjects = _isObject(val1) && _isObject(val2);
            if (
                (areObjects && !deepEqual(val1, val2)) ||
                (!areObjects && val1 !== val2)
            ) {
                return false;
            }
        }
        return true;
    }

    function _isObject(object) {
        return object != null && typeof object === "object";
    }

    function imgChanged(event) {
        product.images = event.detail.product.images;
        product.logos = event.detail.product.logos;
        product.pictos = event.detail.product.pictos;
        product = product;
    }
</script>

{#if isInit}
    <div class="columns is-vcentered" style="padding-left: 1.5em;">
        <div class="return mt-1 pl-2">
            <button class="button is-light">
                <span class="desktop" on:click={() => confirmNavigation()}>
                    <i class="fas fa-chevron-left" /> Retour
                </span>
            </button>
        </div>
        <div class="column is-10">
            <div class="mt-1 pl-2 title-campaign">
                {campaign.name} - {codeOpe}
            </div>
        </div>
    </div>
{/if}

<div id="admin-product-sheet">
    {#if product !== null}
        <div id="form">
            <ProductEditForm
                bind:product
                bind:productBackup
                documentUid={document_uid}
                on:imgChanged={(event) => {
                    imgChanged(event);
                }}
            />
        </div>
        <div id="preview">
            <ProductCase {product} inAdmin={true} />
            <ProductSheet
                {product}
                showCartButtons={false}
                showBackButton={false}
                sendEvents={false}
                crossSell={false}
            />
        </div>
    {/if}
</div>

<style lang="scss">
    @import "../styles/variables.scss";
    #form,
    #preview {
        background-color: white;
        width: 50%;
        float: left;
        display: block;
    }
    .return {
        height: 40px;
        float: left;
        span {
            color: $dark-black;
            font-weight: bold;
            font-size: 1.2em;
            cursor: pointer;
        }
    }
    .title-campaign {
        color: black;
        font-weight: 900 !important;
        font-family: "Gilmer Bold" !important;
        font-size: 1.5rem;
    }
</style>
